import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

export default function EsqueciSenha() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');

  const enviar = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true); setErro('');
    try {
      await api.post('/auth/esqueci-senha', { email: email.trim().toLowerCase() });
      setEnviado(true);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao enviar. Tente novamente.');
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, background: 'var(--bg)' }}>
      <div style={{ maxWidth: 400, width: '100%', background: 'var(--bg2)', padding: 30, borderRadius: 12, border: '1px solid var(--border)' }}>
        <h2 style={{ color: 'var(--orange)', marginTop: 0, textAlign: 'center' }}>🔐 Recuperar Senha</h2>

        {!enviado ? (
          <>
            <p style={{ color: 'var(--text2)', fontSize: 14, textAlign: 'center', marginBottom: 20 }}>
              Digite seu e-mail cadastrado. Enviaremos um link para você redefinir sua senha.
            </p>
            <form onSubmit={enviar}>
              <input
                type="email"
                className="input-field"
                placeholder="seu@email.com"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                style={{ width: '100%', marginBottom: 12, boxSizing: 'border-box' }}
              />
              {erro && <div style={{ color: '#e55', fontSize: 13, marginBottom: 12, textAlign: 'center' }}>⚠️ {erro}</div>}
              <button type="submit" disabled={loading} style={{
                width: '100%', background: 'linear-gradient(135deg, var(--red), var(--orange))',
                color: '#fff', border: 'none', padding: 14, borderRadius: 8,
                fontSize: 15, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.6 : 1
              }}>
                {loading ? 'Enviando...' : '📧 Enviar link de recuperação'}
              </button>
            </form>
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 64, marginBottom: 10 }}>✅</div>
            <h3 style={{ color: '#2ea82e', marginTop: 0 }}>E-mail enviado!</h3>
            <p style={{ color: 'var(--text2)', fontSize: 14, lineHeight: 1.6 }}>
              Se este e-mail existir em nossa base, você receberá as instruções em alguns segundos.
            </p>
            <p style={{ color: 'var(--text3)', fontSize: 12, marginTop: 15 }}>
              💡 Confira também sua caixa de <strong>spam/lixo eletrônico</strong>.
            </p>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <Link to="/login" style={{ color: 'var(--orange)', fontSize: 13, textDecoration: 'none' }}>
            ← Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
}
